import React from 'react';
import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

interface PageHeaderProps {
  title: string;
  description?: string;
  backLink?: string;
  backLabel?: string;
}

export function PageHeader({
  title,
  description,
  backLink = '/',
  backLabel = 'Back to Home',
}: PageHeaderProps) {
  return (
    <div className="mb-8">
      {backLink && (
        <Link
          href={backLink}
          className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-4 group"
        >
          <ArrowLeft className="h-4 w-4 group-hover:-translate-x-1 transition-transform" />
          {backLabel}
        </Link>
      )}
      <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-brand-gradient mb-2 break-words">
        {title}
      </h1>
      {description && (
        <p className="text-muted-foreground text-base sm:text-lg break-words">{description}</p>
      )}
    </div>
  );
}
